import PropTypes from 'prop-types';

const Button = ({ ariaLabel, className, disabled, imgUrl, label, onClick, type, id }) => (
  <button
    aria-label={ariaLabel}
    id={id}
    className={className}
    disabled={disabled}
    onClick={onClick}
    // eslint-disable-next-line react/button-has-type
    type={type}
  >
    {imgUrl && <img src={imgUrl} alt={imgUrl} />}
    {label}
  </button>
);

Button.defaultProps = {
  ariaLabel: '',
  id: null,
  className: '',
  disabled: false,
  imgUrl: '',
  onClick: () => {},
  type: 'button',
};

Button.propTypes = {
  ariaLabel: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  imgUrl: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

export default Button;
